import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { TDLV_LIST, TDLV_ADD, TDLV_FILTER_TASK_STATUS, TDLV_FILTER_SUPPLIERS, TDLV_FILTER_DESTINATIONS } from '../../actions';
import { TaskDeliveryListSuccess, TaskDeliveryListError, TaskDeliveryAddSuccess, TaskDeliveryAddError, TaskDeliveryFilterTaskStatusSuccess, TaskDeliveryFilterSuppliersSuccess, TaskDeliveryFilterDestinationsSuccess } from '../../actions';

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
    }, reject);
  });
}

const onListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'delivery_plan/task_delivery/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onAddAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'delivery_plan/task_delivery/add', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onFilterTaskStatusAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_plan/task_status', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify({})
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onFilterSuppliersAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_plan/suppliers', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify({})
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onFilterDestinationsAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_plan/destinations', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify({})
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

function* onList(data) {
  try { const response = yield call(onListAsync, data.payload); yield put(TaskDeliveryListSuccess(response.data)); }
  catch (error) { yield put(TaskDeliveryListError(error)); }
}

function* onAdd(data) {
  try { const response = yield call(onAddAsync, data.payload); yield put(TaskDeliveryAddSuccess(response.data)); }
  catch (error) { yield put(TaskDeliveryAddError(error)); }
}

function* onFilterTaskStatus() {
  try { const response = yield call(onFilterTaskStatusAsync); yield put(TaskDeliveryFilterTaskStatusSuccess(response.data.data || [])); }
  catch (error) { console.error(error); }
}

function* onFilterSuppliers() {
  try { const response = yield call(onFilterSuppliersAsync); yield put(TaskDeliveryFilterSuppliersSuccess(response.data.data || [])); }
  catch (error) { console.error(error); }
}

function* onFilterDestinations() {
  try { const response = yield call(onFilterDestinationsAsync); yield put(TaskDeliveryFilterDestinationsSuccess(response.data.data || [])); }
  catch (error) { console.error(error); }
}

export function* watchList() { yield takeEvery(TDLV_LIST, onList); }
export function* watchAdd() { yield takeEvery(TDLV_ADD, onAdd); }
export function* watchFilterTaskStatus() { yield takeEvery(TDLV_FILTER_TASK_STATUS, onFilterTaskStatus); }
export function* watchFilterSuppliers() { yield takeEvery(TDLV_FILTER_SUPPLIERS, onFilterSuppliers); }
export function* watchFilterDestinations() { yield takeEvery(TDLV_FILTER_DESTINATIONS, onFilterDestinations); }

export default function* rootSaga() {
  yield all([fork(watchList), fork(watchAdd), fork(watchFilterTaskStatus), fork(watchFilterSuppliers), fork(watchFilterDestinations)]);
}
